import { render, staticRenderFns } from "./EstadoConservacaoIbpModal.vue?vue&type=template&id=36c9f86f&scoped=true"
import script from "./EstadoConservacaoIbpModal.vue?vue&type=script&lang=js"
export * from "./EstadoConservacaoIbpModal.vue?vue&type=script&lang=js"
import style0 from "./EstadoConservacaoIbpModal.vue?vue&type=style&index=0&id=36c9f86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c9f86f",
  null
  
)

export default component.exports